import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { DataCombo } from '../../../../models/combo';

@Component({
  selector: 'app-tabla-productos-ticket',
  templateUrl: './tabla-productos-ticket.component.html',
  styleUrls: ['./tabla-productos-ticket.component.scss']
})
export class TablaProductosTicketComponent implements OnInit {

  @Input() eventProductoDetalles: FormArray;
  @Input() tForm: FormGroup;
  @Input() usuariosCombo: DataCombo[];
  @Input() esDetalle: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

  getNombreUsuario(userId: number): string {
    return this.usuariosCombo?.find(u => u.value === userId)?.label || 'Usuario eliminado';
  }

}
